// extracted by mini-css-extract-plugin
module.exports = {"bannerWrapper":"styles_bannerWrapper__oTsSG","widgetWrapper":"styles_widgetWrapper__kRqc0"};
module.exports.__checksum = "e17e417340ad"